import script from "./TipaltiMfaDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TipaltiMfaDialog.vue?vue&type=script&setup=true&lang=js"

import "./TipaltiMfaDialog.vue?vue&type=style&index=0&id=089be1db&lang=scss"

const __exports__ = script;

export default __exports__